module.exports = __webpack_public_path__ + "img/NehmtMichMitAufDieReise.6d93422f.jpg";